<lib-fo-toolbar-sidebar #toolbarSidebar [isSidebarOnToolbar]="true" [isLandingPage]="true" [isDisableLogBook]="true"
  [isShowMenuButton]="isShowSidebarButton">
  <div appContent id="landing-container" [ngClass]="{'open-user-profile': !toolbarSidebar.isToolbarClosed()}">
    <div class="hotel-select-container">
      <div class="hotel-select-content" [style]="{ opacity: loaded ? '1' : '0' }">
        <h1 class="hotel-select-title">
          {{ "form_landing_app.available_hotels" | translate }}
        </h1>
        <div class="hotel-select-form">
          <mat-form-field class="hotel-form-field full-width" hideRequiredMarker>
            <mat-label>{{ "form_landing_app.select_hotels" | translate }}</mat-label>
            <mat-select name="hotel" [formControl]="formHotel" required>
              <mat-option>
                <ngx-mat-select-search [formControl]="filteringCtrl"
                  placeholderLabel="{{'form_register_app.search.search_hotel' | translate }}"
                  noEntriesFoundLabel="{{'form_register_app.search.notfound_hotel' | translate }}">
                </ngx-mat-select-search>
              </mat-option>
              <mat-select-trigger>
                {{ formHotel.value?.name }}
              </mat-select-trigger>
              <mat-option *ngFor="let hotel of hotels" [value]="hotel">
                <div class="hotel-option-container">
                  <p>{{ hotel.name }}</p>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="products-container" [style]="{ opacity: loaded ? '1' : '0' }">
      <ng-container *ngFor="let app of products">
        <div class="app-container" [class]="{'disabled-app': !app.enabled}" (click)="selectAppClick(app)">
          <div #productStatus class="product-status hidden"
            [ngClass]="{'display-flex': !app.enabled && formHotel.value}">
            <a [href]="app.info" target="_blank" class="avalable" [ngClass]="{'no-link': !app.info}"
              *ngIf="app.available" (click)="!app.info ? $event.preventDefault() : $event">Available
              Now!</a>
            <a class="coming-soon" *ngIf="!app.available && app.comingSoon">Coming Soon!</a>
          </div>
          <div class="app-content">
            <div class="image-container">
              <div class="overlap-app-image"></div>
              <img #image [src]="app.image" alt="{{app.name}}" class="app-image fade-in"
                (load)="handleImageLoad(image, imagePlaceholder, productStatus)"
                (error)="handleImageError(imagePlaceholder)" />
              <div #imagePlaceholder class="image-placeholder-container skeleton-loading">
                <div class="css-spinner"></div>
                <span class="loading-text">Loading...</span>
              </div>
            </div>
            <div class="app-label"> {{app.name}} </div>
          </div>
        </div>
      </ng-container>
    </div>

    <lib-user-profile class="user-profile" (closeProfile)="toolbarSidebar.resetToolbar()"
      [userProfile]="toolbarSidebar.getReqUserProfile()" [userAuthen]="toolbarSidebar.getReqUserAuthen()"
      *ngIf="!toolbarSidebar.isToolbarClosed()">
    </lib-user-profile>
  </div>
</lib-fo-toolbar-sidebar>